/**
 * PipedriveAPIV1Lib
 *
 * This file was automatically generated by APIMATIC v2.0 ( https://apimatic.io ).
 */

'use strict';

const FieldType = require('../lib/Models/FieldType');
const MailMessage = require('../lib/Models/MailMessage');
const MailMessageData = require('../lib/Models/MailMessageData');
const MailParticipant = require('../lib/Models/MailParticipant');
const MailServiceBaseResponse = require('../lib/Models/MailServiceBaseResponse');
const Activity = require('../lib/Models/Activity');
const BasicDeal = require('../lib/Models/BasicDeal');
const NewDeal = require('../lib/Models/NewDeal');
const GetAddedDeal = require('../lib/Models/GetAddedDeal');
const GetDuplicatedDeal = require('../lib/Models/GetDuplicatedDeal');
const GetMergedDeal = require('../lib/Models/GetMergedDeal');
const AddedDealFollower = require('../lib/Models/AddedDealFollower');
const DeleteDeal = require('../lib/Models/DeleteDeal');
const DeleteDealFollower = require('../lib/Models/DeleteDealFollower');
const DeleteDealParticipant = require('../lib/Models/DeleteDealParticipant');
const DeleteDealProduct = require('../lib/Models/DeleteDealProduct');
const BasicDealProduct = require('../lib/Models/BasicDealProduct');
const NewDealProduct = require('../lib/Models/NewDealProduct');
const BaseCurrency = require('../lib/Models/BaseCurrency');
const Currencies = require('../lib/Models/Currencies');
const Note = require('../lib/Models/Note');
const GetNotes = require('../lib/Models/GetNotes');
const PostNote = require('../lib/Models/PostNote');
const DeleteNote = require('../lib/Models/DeleteNote');
const BaseNoteDealTitle = require('../lib/Models/BaseNoteDealTitle');
const BaseNote = require('../lib/Models/BaseNote');
const NoteCreatorUser = require('../lib/Models/NoteCreatorUser');
const AdditionalData = require('../lib/Models/AdditionalData');
const AdditionalDataWithPaginationDetails =
  require('../lib/Models/AdditionalDataWithPaginationDetails');
const BasicGoal = require('../lib/Models/BasicGoal');
const NewGoal = require('../lib/Models/NewGoal');
const BasicOrganizationField = require('../lib/Models/BasicOrganizationField');
const NewOrganizationField = require('../lib/Models/NewOrganizationField');
const BasicOrganization = require('../lib/Models/BasicOrganization');
const NewOrganization = require('../lib/Models/NewOrganization');
const OrganizationRelationship = require('../lib/Models/OrganizationRelationship');
const BasicPerson = require('../lib/Models/BasicPerson');
const NewPerson = require('../lib/Models/NewPerson');
const NewPersonField = require('../lib/Models/NewPersonField');
const Pipeline = require('../lib/Models/Pipeline');
const Product = require('../lib/Models/Product');
const NewFollowerResponse = require('../lib/Models/NewFollowerResponse');
const DeleteProductFollowerResponse = require('../lib/Models/DeleteProductFollowerResponse');
const BasicProductField = require('../lib/Models/BasicProductField');
const NewProductField = require('../lib/Models/NewProductField');
const ProductField = require('../lib/Models/ProductField');
const GetAllProductFieldsResponse = require('../lib/Models/GetAllProductFieldsResponse');
const GetProductFieldResponse = require('../lib/Models/GetProductFieldResponse');
const DeleteMultipleProductFieldsResponse =
  require('../lib/Models/DeleteMultipleProductFieldsResponse');
const DeleteProductFieldResponse = require('../lib/Models/DeleteProductFieldResponse');
const BaseRole = require('../lib/Models/BaseRole');
const RoleAssignment = require('../lib/Models/RoleAssignment');
const SubRole = require('../lib/Models/SubRole');
const FullRole = require('../lib/Models/FullRole');
const GetRoles = require('../lib/Models/GetRoles');
const RoleSettings = require('../lib/Models/RoleSettings');
const RolesAdditionalData = require('../lib/Models/RolesAdditionalData');
const PostRoles = require('../lib/Models/PostRoles');
const DeleteRole = require('../lib/Models/DeleteRole');
const GetRole = require('../lib/Models/GetRole');
const PutRole = require('../lib/Models/PutRole');
const DeleteRoleAssignment = require('../lib/Models/DeleteRoleAssignment');
const GetRoleAssignments = require('../lib/Models/GetRoleAssignments');
const PostRoleAssignment = require('../lib/Models/PostRoleAssignment');
const GetRoleSubroles = require('../lib/Models/GetRoleSubroles');
const GetRoleSettings = require('../lib/Models/GetRoleSettings');
const PostRoleSettings = require('../lib/Models/PostRoleSettings');
const Stage = require('../lib/Models/Stage');
const PermissionSets = require('../lib/Models/PermissionSets');
const PermissionSetsItem = require('../lib/Models/PermissionSetsItem');
const SinglePermissionSetsItem = require('../lib/Models/SinglePermissionSetsItem');
const UserAssignmentsToPermissionSet = require('../lib/Models/UserAssignmentsToPermissionSet');
const UserAssignmentToPermissionSet = require('../lib/Models/UserAssignmentToPermissionSet');
const CreateTeam = require('../lib/Models/CreateTeam');
const UpdateTeam = require('../lib/Models/UpdateTeam');
const BaseTeam = require('../lib/Models/BaseTeam');
const Teams = require('../lib/Models/Teams');
const UserIDs = require('../lib/Models/UserIDs');
const BaseUser = require('../lib/Models/BaseUser');
const User = require('../lib/Models/User');
const Users = require('../lib/Models/Users');
const BaseUserMe = require('../lib/Models/BaseUserMe');
const UserMe = require('../lib/Models/UserMe');
const UserConnections = require('../lib/Models/UserConnections');
const GetDeal = require('../lib/Models/GetDeal');
const GetDeals = require('../lib/Models/GetDeals');
const GetDealsByName = require('../lib/Models/GetDealsByName');
const GetDealsSummary = require('../lib/Models/GetDealsSummary');
const GetDealsTimeline = require('../lib/Models/GetDealsTimeline');
const DealUserData = require('../lib/Models/DealUserData');
const DealPersonData = require('../lib/Models/DealPersonData');
const DealOrganizationData = require('../lib/Models/DealOrganizationData');
const GetProductAttachementDetails = require('../lib/Models/GetProductAttachementDetails');
const GetAddProductAttachementDetails = require('../lib/Models/GetAddProductAttachementDetails');
const ProductAttachementFields = require('../lib/Models/ProductAttachementFields');
const DealNonStrictModeFields = require('../lib/Models/DealNonStrictModeFields');
const DealStrictModeFields = require('../lib/Models/DealStrictModeFields');
const BaseDeal = require('../lib/Models/BaseDeal');
const BaseResponse = require('../lib/Models/BaseResponse');
const CommonMailThread = require('../lib/Models/CommonMailThread');
const BaseMailThread = require('../lib/Models/BaseMailThread');
const MailThread = require('../lib/Models/MailThread');
const MailThreadOne = require('../lib/Models/MailThreadOne');
const MailThreadParticipant = require('../lib/Models/MailThreadParticipant');
const BaseMailThreadMessages = require('../lib/Models/BaseMailThreadMessages');
const MailThreadMessages = require('../lib/Models/MailThreadMessages');
const MailThreadDelete = require('../lib/Models/MailThreadDelete');
const MailThreadPut = require('../lib/Models/MailThreadPut');
const GlobalMessageGet = require('../lib/Models/GlobalMessageGet');
const GlobalMessageBaseResponse = require('../lib/Models/GlobalMessageBaseResponse');
const GlobalMessageData = require('../lib/Models/GlobalMessageData');
const GlobalMessageUserData = require('../lib/Models/GlobalMessageUserData');
const GlobalMessageDelete = require('../lib/Models/GlobalMessageDelete');
const AdditionalData3 = require('../lib/Models/AdditionalData3');
const AdditionalData4 = require('../lib/Models/AdditionalData4');
const AdditionalData5 = require('../lib/Models/AdditionalData5');
const AdditionalData6 = require('../lib/Models/AdditionalData6');
const Age = require('../lib/Models/Age');
const AverageTimeToWon = require('../lib/Models/AverageTimeToWon');
const CreatorUserId = require('../lib/Models/CreatorUserId');
const Data = require('../lib/Models/Data');
const Data2 = require('../lib/Models/Data2');
const Data3 = require('../lib/Models/Data3');
const Data4 = require('../lib/Models/Data4');
const Data5 = require('../lib/Models/Data5');
const Data6 = require('../lib/Models/Data6');
const Data7 = require('../lib/Models/Data7');
const Data8 = require('../lib/Models/Data8');
const Data9 = require('../lib/Models/Data9');
const Data10 = require('../lib/Models/Data10');
const Data11 = require('../lib/Models/Data11');
const Data12 = require('../lib/Models/Data12');
const Data13 = require('../lib/Models/Data13');
const Data14 = require('../lib/Models/Data14');
const Data15 = require('../lib/Models/Data15');
const Data16 = require('../lib/Models/Data16');
const Data17 = require('../lib/Models/Data17');
const Data18 = require('../lib/Models/Data18');
const Data19 = require('../lib/Models/Data19');
const Data20 = require('../lib/Models/Data20');
const Data21 = require('../lib/Models/Data21');
const Data24 = require('../lib/Models/Data24');
const Data25 = require('../lib/Models/Data25');
const Data26 = require('../lib/Models/Data26');
const Data27 = require('../lib/Models/Data27');
const Data28 = require('../lib/Models/Data28');
const Data29 = require('../lib/Models/Data29');
const Data30 = require('../lib/Models/Data30');
const Data31 = require('../lib/Models/Data31');
const Data32 = require('../lib/Models/Data32');
const Deal1 = require('../lib/Models/Deal1');
const SearchDeals = require('../lib/Models/SearchDeals');
const DealsResponse = require('../lib/Models/DealsResponse');
const Email = require('../lib/Models/Email');
const Language = require('../lib/Models/Language');
const Organization1 = require('../lib/Models/Organization1');
const OrgId = require('../lib/Models/OrgId');
const Pagination = require('../lib/Models/Pagination');
const Pagination1 = require('../lib/Models/Pagination1');
const Parties = require('../lib/Models/Parties');
const Person1 = require('../lib/Models/Person1');
const PersonId = require('../lib/Models/PersonId');
const Phone = require('../lib/Models/Phone');
const RelatedObjects = require('../lib/Models/RelatedObjects');
const StayInPipelineStages = require('../lib/Models/StayInPipelineStages');
const Totals = require('../lib/Models/Totals');
const UserId = require('../lib/Models/UserId');
const ValuesTotal = require('../lib/Models/ValuesTotal');
const WebhooksResponse = require('../lib/Models/WebhooksResponse');
const WebhooksResponse1 = require('../lib/Models/WebhooksResponse1');
const WeightedValuesTotal = require('../lib/Models/WeightedValuesTotal');
const OAuthToken = require('../lib/Models/OAuthToken');
const FailResponseException = require('../lib/Exceptions/FailResponseException');
const UnauthorizedException = require('../lib/Exceptions/UnauthorizedException');
const BaseResponseErrorException = require('../lib/Exceptions/BaseResponseErrorException');
const Webhooks400ErrorException = require('../lib/Exceptions/Webhooks400ErrorException');
const Webhooks400ErrorErrorException = require('../lib/Exceptions/Webhooks400ErrorErrorException');
const OAuthProviderException = require('../lib/Exceptions/OAuthProviderException');
const SearchProducts = require('../lib/Models/SearchProducts');
const ItemSearchByField = require('../lib/Models/ItemSearchByField');

const classMap = {
    ItemSearchByField,
    SearchDeals,
    SearchProducts,
    FieldType,
    MailMessage,
    MailMessageData,
    MailParticipant,
    MailServiceBaseResponse,
    Activity,
    BasicDeal,
    NewDeal,
    GetAddedDeal,
    GetDuplicatedDeal,
    GetMergedDeal,
    AddedDealFollower,
    DeleteDeal,
    DeleteDealFollower,
    DeleteDealParticipant,
    DeleteDealProduct,
    BasicDealProduct,
    NewDealProduct,
    BaseCurrency,
    Currencies,
    Note,
    GetNotes,
    PostNote,
    DeleteNote,
    BaseNoteDealTitle,
    BaseNote,
    NoteCreatorUser,
    AdditionalData,
    AdditionalDataWithPaginationDetails,
    BasicGoal,
    NewGoal,
    BasicOrganizationField,
    NewOrganizationField,
    BasicOrganization,
    NewOrganization,
    OrganizationRelationship,
    BasicPerson,
    NewPerson,
    NewPersonField,
    Pipeline,
    Product,
    NewFollowerResponse,
    DeleteProductFollowerResponse,
    BasicProductField,
    NewProductField,
    ProductField,
    GetAllProductFieldsResponse,
    GetProductFieldResponse,
    DeleteMultipleProductFieldsResponse,
    DeleteProductFieldResponse,
    BaseRole,
    RoleAssignment,
    SubRole,
    FullRole,
    GetRoles,
    RoleSettings,
    RolesAdditionalData,
    PostRoles,
    DeleteRole,
    GetRole,
    PutRole,
    DeleteRoleAssignment,
    GetRoleAssignments,
    PostRoleAssignment,
    GetRoleSubroles,
    GetRoleSettings,
    PostRoleSettings,
    Stage,
    PermissionSets,
    PermissionSetsItem,
    SinglePermissionSetsItem,
    UserAssignmentsToPermissionSet,
    UserAssignmentToPermissionSet,
    CreateTeam,
    UpdateTeam,
    BaseTeam,
    Teams,
    UserIDs,
    BaseUser,
    User,
    Users,
    BaseUserMe,
    UserMe,
    UserConnections,
    GetDeal,
    GetDeals,
    GetDealsByName,
    GetDealsSummary,
    GetDealsTimeline,
    DealUserData,
    DealPersonData,
    DealOrganizationData,
    GetProductAttachementDetails,
    GetAddProductAttachementDetails,
    ProductAttachementFields,
    DealNonStrictModeFields,
    DealStrictModeFields,
    BaseDeal,
    BaseResponse,
    CommonMailThread,
    BaseMailThread,
    MailThread,
    MailThreadOne,
    MailThreadParticipant,
    BaseMailThreadMessages,
    MailThreadMessages,
    MailThreadDelete,
    MailThreadPut,
    GlobalMessageGet,
    GlobalMessageBaseResponse,
    GlobalMessageData,
    GlobalMessageUserData,
    GlobalMessageDelete,
    AdditionalData3,
    AdditionalData4,
    AdditionalData5,
    AdditionalData6,
    Age,
    AverageTimeToWon,
    CreatorUserId,
    Data,
    Data2,
    Data3,
    Data4,
    Data5,
    Data6,
    Data7,
    Data8,
    Data9,
    Data10,
    Data11,
    Data12,
    Data13,
    Data14,
    Data15,
    Data16,
    Data17,
    Data18,
    Data19,
    Data20,
    Data21,
    Data24,
    Data25,
    Data26,
    Data27,
    Data28,
    Data29,
    Data30,
    Data31,
    Data32,
    Deal1,
    DealsResponse,
    Email,
    Language,
    Organization1,
    OrgId,
    Pagination,
    Pagination1,
    Parties,
    Person1,
    PersonId,
    Phone,
    RelatedObjects,
    StayInPipelineStages,
    Totals,
    UserId,
    ValuesTotal,
    WebhooksResponse,
    WebhooksResponse1,
    WeightedValuesTotal,
    OAuthToken,
    FailResponseException,
    UnauthorizedException,
    BaseResponseErrorException,
    Webhooks400ErrorException,
    Webhooks400ErrorErrorException,
    OAuthProviderException,
};

/**
 * Factory class to create instances of models and exception classes
 */
class ModelFactory {
    /**
     * Creates instance of a model class
     * @param  modelName  {string}  Name of class to instantiate
     * @returns  {object} Instance of the model class
     */
    static getInstance(modelName) {
        return new classMap[modelName]();
    }
}

module.exports = ModelFactory;
